<template>
    <LoadingComponent :props="loading" />

    <section class="mb-3 sm:mb-10" v-if="randomizedBrands.length > 0">
        <div class="container">
            <h2 class="capitalize text-1xl sm:text-2xl font-semibold relative z-10 -mb-10">
                {{ $t('label.popular_brands') }}
            </h2>
            <div class="relative z-0">
                <Swiper dir="ltr" :speed="4500" :autoplay="autoplayOptions" :loop="randomizedBrands.length > 1"
                    :loopAdditionalSlides="randomizedBrands.length" :navigation="true" :modules="modules"
                    class="navigate-swiper brand-auto-swiper" :breakpoints="breakpoints">
                    <SwiperSlide v-for="(brand, index) in randomizedBrands" :key="index" class="mobile:!w-[120px]">
                        <router-link :to="{name: 'frontend.product', query:{ brand: brand.id }}" class="w-full rounded-2xl overflow-hidden border group border ">
                            <figure v-if="showBrandImage" class="w-full flex items-center justify-center overflow-hidden border-b border-dashed">
                                <img :src="brand.cover" alt="brand" class="w-full object-contain">
                            </figure>
                            <span :class="showBrandImage ? 'py-2 sm:text-md' : 'py-5 sm:text-base'" class="text-sm font-medium capitalize text-center bg-white block group-hover:text-primary px-2 whitespace-nowrap overflow-hidden text-ellipsis truncate">
                                    {{ brand.name }}
                                </span>
                        </router-link>
                    </SwiperSlide>
                    <div class="brand-fade-edge brand-fade-left"></div>
                    <div class="brand-fade-edge brand-fade-right"></div>
                </Swiper>
            </div>
        </div>
    </section>
</template>

<script>
import statusEnum from "../../../enums/modules/statusEnum";
import LoadingComponent from "../components/LoadingComponent";
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import ENV from "../../../config/env";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
    name: "ProductBrandComponent",
    components: {
        Swiper, SwiperSlide,
        LoadingComponent
    },
    data() {
        return {
            loading: {
                isActive: false,
            },
            randomizedBrands: [],
            autoplayOptions: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            breakpoints: {
                0: {slidesPerView: 'auto', spaceBetween: 16},
                640: {slidesPerView: 4, spaceBetween: 24},
                768: {slidesPerView: 5, spaceBetween: 24},
                1024: {slidesPerView: 6, spaceBetween: 24}
            },
        }
    },
    setup() {
        return {
            modules: [Navigation, Pagination, Autoplay],
        }
    },
    computed: {
        showBrandImage: function () {
            return ENV.SHOW_BRAND_IMAGE === "true" || ENV.SHOW_BRAND_IMAGE === true || ENV.SHOW_BRAND_IMAGE === 1 || ENV.SHOW_BRAND_IMAGE === "1" ? true : false;
        },
        brands: function () {
            return this.$store.getters["frontendProductBrand/lists"];
        },
        filteredBrands: function () {
            return (this.brands || []).filter((brand) => Number(brand.id) !== 1);
        },
    },
    methods: {
        shuffleBrands: function (brands) {
            if (!Array.isArray(brands) || brands.length === 0) {
                this.randomizedBrands = [];
                return;
            }
            const clone = [...brands];
            for (let i = clone.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [clone[i], clone[j]] = [clone[j], clone[i]];
            }
            let result = [...clone];
            while (result.length > 0 && result.length < 16) {
                result = [...result, ...clone];
            }
            this.randomizedBrands = result;
        }
    },
    mounted() {
        this.loading.isActive = true;
        this.$store.dispatch("frontendProductBrand/lists", {
            paginate: 0,
            order_column: "id",
            order_type: "asc",
            status: statusEnum.ACTIVE,
        }).then(res => {
            this.shuffleBrands(this.filteredBrands);
            this.loading.isActive = false;
        }).catch((err) => {
            this.loading.isActive = false;
        });
    },
    watch: {
        filteredBrands: {
            handler(newBrands) {
                this.shuffleBrands(newBrands);
            },
            immediate: true,
        }
    },
}
</script>

<style scoped>
:deep(.brand-auto-swiper .swiper-wrapper) {
    transition-timing-function: linear;
}

.brand-fade-edge {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 64px;
    pointer-events: none;
    z-index: 2;
}

.brand-fade-left {
    left: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
}

.brand-fade-right {
    right: 0;
    background: linear-gradient(to left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
}

:deep(.brand-auto-swiper .swiper-button-prev),
:deep(.brand-auto-swiper .swiper-button-next) {
    z-index: 4;
}
</style>

